module.exports = __webpack_public_path__ + "img/ic_32_workout_item_time.5c239e49.svg";